export default {
  title: 'Shop domain',
  description:
    'Serve your restaurants’ online shops on a domain of your own instead of the shared address — for example pizza-mario.order-yourbrand.com. You add two DNS records once; every restaurant you add later gets its address automatically.',
  read_only_description:
    'The domain this partner’s restaurant shops are served under. Only the partner can connect or change it.',
  read_only_empty: 'This partner has not connected a shop domain.',
  not_connected: {
    label: 'Domain for your restaurants’ shops',
    hint: 'A domain or subdomain you own, such as order-yourbrand.com. It has to be a different domain from the one your team’s apps run on — not a subdomain of it.',
    placeholder: 'order-yourbrand.com',
    connect: 'Connect',
  },
  status: {
    pending_dns: 'Waiting for DNS',
    active: 'Live',
    failed: 'Action needed',
    disabled: 'Unlinked',
  },
  primary_badge: 'Primary',
  summary: {
    pending: 'We are waiting for your DNS records. This usually takes a few minutes and can take a few hours.',
    failed:
      'We could not confirm every record in time. Fix the record marked below, then press Check again — we start checking again from there.',
    failed_leave: 'To connect a different domain instead, unlink this one first.',
    live: '{{host}} is live.',
    primary: 'Every new restaurant gets its address under it automatically.',
    standby:
      'Make it primary to give it to every new restaurant automatically. Restaurants already on another domain stay where they are.',
    regressed:
      '{{host}} is live, but a record below stopped checking out. Your shops are still online — fix the record at your DNS provider.',
  },
  instructions: {
    title: 'How to add the records',
    step_provider: 'Sign in where the DNS of {{root}} is managed — usually the company you bought the domain from.',
    step_add: 'Add each record below exactly as shown: its type, its name and its value.',
    step_check: 'Save, then click “{{button}}”. We also keep checking on our own.',
    tip_name:
      'Most providers want only the part before {{root}} in the name field — _foodamigos-verify and *. The full name is shown underneath, for providers that ask for it.',
    tip_wildcard:
      'The * record sends every address under {{root}} to your shops, so you never add a record per restaurant.',
    tip_existing:
      'Existing records for {{root}}, such as your website, mail or www, keep working: the * record only answers names that have no record of their own. If {{root}} already has a * record, replace it with ours.',
    tip_cloudflare: 'On Cloudflare, set the CNAME record to DNS only (grey cloud), or we cannot see it.',
  },
  records: {
    title: 'Add these DNS records for {{root}} at your domain provider',
  },
  example: 'A restaurant will then be at an address such as {{host}}.',
  example_label: 'your-restaurant',
  buttons: {
    check_again: 'Check again',
    make_primary: 'Make primary',
    unlink: 'Unlink',
    retry: 'Try again',
  },
  primary_unavailable: 'Available once the domain is live.',
  unlink_blocked_one: '{{count}} restaurant is still on this domain. Move it to another domain before unlinking.',
  unlink_blocked_other: '{{count}} restaurants are still on this domain. Move them to another domain before unlinking.',
  unlink_confirm: {
    title: 'Unlink {{host}}?',
    description: 'You can connect {{host}} again later.',
    description_primary:
      'New restaurants get an address on the shared domain again. You can connect {{host}} again later.',
    ok: 'Unlink',
  },
  toasts: {
    load_error: 'Could not load your shop domain',
    load_error_read_only: 'Could not load this partner’s shop domain',
    connected: 'Domain connected — now add the records below',
    connect_failed: 'Could not connect the domain',
    check_started: 'Checking again…',
    check_failed: 'Could not start the check. Try again in a minute.',
    primary_set: 'New restaurants now get this domain',
    primary_failed: 'Could not make this domain primary',
    unlinked: 'Domain unlinked',
    unlink_failed: 'Could not unlink the domain',
    unlink_has_restaurants_one:
      '{{count}} restaurant is still on {{host}}: {{names}}. Move it to another domain before unlinking.',
    unlink_has_restaurants_other:
      '{{count}} restaurants are still on {{host}}: {{names}}. Move them to another domain before unlinking.',
    gone: '{{host}} is no longer connected — it may have been unlinked in another tab.',
  },
};
